var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrowForwardRtl = function SvgLongArrowForwardRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.57 68.572c-.573.571-1.5.57-2.073-.001L10.43 52.51l-.027-.027a1.46 1.46 0 0 1 .027-2.04l16.039-16.015.027-.027a1.47 1.47 0 0 1 2.046.026l.026.028a1.46 1.46 0 0 1-.026 2.04L15.018 50H89.5l.144.007A1.5 1.5 0 0 1 89.5 53H15.06l13.512 13.504.026.027a1.46 1.46 0 0 1-.028 2.041"
  })));
};
export default SvgLongArrowForwardRtl;